import React from 'react';

import Button, { colorProps, typeProps } from './Button';
import ButtonToggle from './ButtonToggle';
import ButtonLayouts from './ButtonLayouts';

import './styles/style.scss';

export default Button;
export { ButtonToggle };

export { colorProps as buttonColorProps };
export { typeProps as buttonTypeProps };

export const ButtonLayout = props => <ButtonLayouts type="layout" {...props} />;
ButtonLayout.displayName = 'ButtonLayout';

export const ButtonGroup = props => <ButtonLayouts type="group" {...props} />;
ButtonGroup.displayName = 'ButtonGroup';

export const ButtonPrimary = props => <Button type="primary" {...props} />;
ButtonPrimary.displayName = 'ButtonPrimary';

export const ButtonSecondary = props => <Button type="secondary" {...props} />;
ButtonSecondary.displayName = 'ButtonSecondary';

export const ButtonTertiary = props => <Button type="tertiary" {...props} />;
ButtonTertiary.displayName = 'ButtonTertiary';

export const ButtonLink = props => <Button type="link" {...props} />;
ButtonLink.displayName = 'ButtonLink';



// WEBPACK FOOTER //
// ./src/components/Button/index.js